import React from 'react'

import { ReactComponent as FileTextIcon } from '@app/assets//Small/Outline/FileText.svg'
import { ReactComponent as XIcon } from '@app/assets//Small/Outline/X.svg'
import './index.scss'
import { logger } from '@app/common/logger/logger'
import { bemJoin } from '@app/lib/bem'
import { openDocuments } from '@app/modules/Auth/documentLink'

interface DocumentLabelProps {
  filename: string
  fileUrl?: string
  onRemove?: () => void
}

export const DocumentLabel = ({ filename, fileUrl, onRemove }: DocumentLabelProps) => {
  const b = bemJoin('document-label')

  const handleClick = () => {
    if (fileUrl) {
      openDocuments([fileUrl]).catch((error) => {
        logger.error(`unable to handleClick on DocumentLabel with ${error.message}`)
      })
    }
  }

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation()
    onRemove?.()
  }

  return (
    <div className={b({ clickable: !!fileUrl })} onClick={handleClick}>
      <FileTextIcon />
      <span className={b('filename')}>{filename}</span>
      {onRemove && (
        <a className={b('remove-button')} onClick={handleRemove} role='button' tabIndex={0}>
          <XIcon />
        </a>
      )}
    </div>
  )
}
